import { FormattedMessage } from 'react-intl';
import { BreadcrumbRoute } from 'types/breadcrumbs';

export const breadcrumbRoutes: BreadcrumbRoute[] = [
  // Patients
  {
    pattern: '/apps/patients/list',
    breadcrumbs: [{ title: <FormattedMessage id="patient-list" /> }]
  },
  {
    pattern: '/apps/patients/details/:id',
    breadcrumbs: [
      { title: <FormattedMessage id="patient-list" />, url: '/apps/patients/list' },
      { title: (_params: Record<string, string>, data?: Record<string, string>) => data?.patientIdentifier || '...' }
    ]
  },

  // Assessments
  {
    pattern: '/apps/assessment/list',
    breadcrumbs: [{ title: <FormattedMessage id="assessments" /> }]
  },
  {
    pattern: '/apps/assessment/details/:id',
    breadcrumbs: [
      { title: <FormattedMessage id="assessments" />, url: '/apps/assessment/list' },
      {
        title: (_params: Record<string, string>, data?: Record<string, string>) => data?.patientIdentifier || '...',
        url: (_params: Record<string, string>, data?: Record<string, string>) =>
          data?.patientId ? `/apps/patients/details/${data.patientId}` : undefined
      },
      { title: '' }
    ]
  },
  {
    pattern: '/apps/assessment/templates',
    breadcrumbs: [
      { title: <FormattedMessage id="assessments" />, url: '/apps/assessment/list' },
      { title: <FormattedMessage id="templates" /> }
    ]
  },

  // Visits
  {
    pattern: '/apps/visit/list',
    breadcrumbs: [{ title: <FormattedMessage id="visit-list" /> }]
  },
  {
    pattern: '/apps/visit/details/:id',
    breadcrumbs: [
      { title: <FormattedMessage id="visit-list" />, url: '/apps/visit/list' },
      {
        title: (_params: Record<string, string>, data?: Record<string, string>) => data?.patientIdentifier || '...',
        url: (_params: Record<string, string>, data?: Record<string, string>) =>
          data?.patientId ? `/apps/patients/details/${data.patientId}` : undefined
      },
      { title: '' }
    ]
  },

  // Team
  {
    pattern: '/apps/team/list',
    breadcrumbs: [{ title: <FormattedMessage id="team" /> }]
  },

  // Profile (not in navigation menu)
  {
    pattern: '/apps/profiles/account/my-account',
    breadcrumbs: [{ title: <FormattedMessage id="profile" /> }]
  },
  {
    pattern: '/apps/profiles/account/password',
    breadcrumbs: [{ title: <FormattedMessage id="profile" /> }]
  }
];
